export default "472b93840d145331.svg"